module.exports = "<div>\r\n  <ul class=\"bottom-nav\">\r\n    <li class=\"left\">\r\n        <p ><a target=\"_blank\" href=\"https://www.beaconsoftco.com/\">\r\n          <img class=\"small-image\" src=\"assets/beaconflat.png\">\r\n        </a>\r\n        </p>\r\n    </li>\r\n  \r\n    <li class=\"right\"><span> <br><a [routerLink]=\"['/Help']\" >Help/FeedBack</a> </span></li><li class=\"right\"></li>\r\n  </ul>\r\n </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/status-bar/status-bar.component.html
// module id = ./src/app/Components/status-bar/status-bar.component.html
// module chunks = main